import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Paper, Table, TableBody, TableCell, TablePagination, TableRow} from "@material-ui/core";
import EnhancedTableHead from "./EnhancedTableHead";
import EnhancedToolbar from "./EnhancedToolbar";
import TablePaginationActions from './TablePaginationActions';
import Link from '@material-ui/core/Link';
import {Link as RouterLink} from 'react-router-dom';
import dartopolis from '../../DartopolisClient';
import {Trans, withTranslation} from "react-i18next";
import ErrorSnackbar from "../Snackbars/ErrorSnackbar";
import countryList from '../CountrySelect/CountryList';
import {getSort, sortData} from '../../util/Util';
import {connect} from "react-redux";
import actions from "../../reducers/playersList/playersListActions";


const styles = theme => ({
    root: {
        width: '100%'
    },
    table: {
        minWidth: 1020,
        width: '100%'
    },
    tableWrapper: {
        width: '100%',
        overflowX: 'auto'
    },
    regLink: {
        marginTop: 10
    }
});

class PlayersList extends Component {
    loadInstance() {
        dartopolis.loadInstance('Czech Open', (data) => {
            const selectedCategory = data.categories[0].id;
            this.setState({
                instance: data,
                selectedCategory: selectedCategory,
                errorCode: null,
            });
            this.fetchPlayers(selectedCategory);
        }, (error) => {
            this.setState({
                errorCode: '220000',
                errorMessage: 'Error fetching tournament information: ' + error
            });
        });
    };

    multiplicity(category) {
        let mult = 1;
        this.props.categories.forEach((cat) => {
            if (cat.id === category) {
                mult = cat.multiplicity;
            }
        });
        return mult;
    };

    fetchPlayers(category) {
        // We're now using the saga to load
        /*
        dartopolis.fetchPlayers(category, (data) => {
            const columns = initColumns(this.multiplicity(category));
            this.setState({
                page: 0,
                data: data,
                columns: columns,
                errorCode: null,
                errorMessage: null,
            });

        }, (error) => {
            this.setState({
                errorCode: '220002',
                errorMessage: 'Error fetching player list: ' + error
            });
        });
         */
    };

    componentDidMount() {
        // this will wait for the tournament instance to be loaded, and then automagically select the first
        // category and load the entries
        this.props.loadCategoryEntries();
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.props.orderBy === property && this.props.order === 'desc') {
            order = 'asc';
        }

        this.props.setPageSort(order, orderBy);
    };

    handleChangePage = (event, page) => {
        this.props.setPageNum(page);
    };

    handleChangeRowsPerPage = event => {
        this.props.setRowsPerPage(event.target.value);
    };

    handleCategorySelect = event => {
        const nextCategory = event.target.value;
        if (nextCategory && this.props.selectedCategoryId !== nextCategory) {
            this.props.setPage(0, 'asc', null);
            this.props.loadCategoryEntries(nextCategory);
            // this.setState({
            //     selectedCategory: nextCategory,
            //     page: 0,
            //     data: [],
            //     order: 'asc',
            //     orderBy: null
            // });
            // this.fetchPlayers(nextCategory);
        }
    };

    render() {
        const {classes} = this.props;
        const {order, orderBy, data, page, rowsPerPage} = this.props;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

        const sortedData = sortData(data, getSort(order, orderBy));
        const pageData = sortedData.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

        const {t} = this.props;
        let snackbar = null;
        // TODO - this will need to be moved to a standardized error snackbar on the main page
        if (this.props.errorCode) {
            snackbar = <ErrorSnackbar message={this.props.errorMessage} />;
        }

        const countryMapReducer = (array) => {
            const cm = array.reduce((obj, item) => {
                obj[item.code] = item;
                return obj;
            }, {});
            return cm;
        };
        const countryMap = countryMapReducer(countryList);

        return (
            <>
                <Paper className={classes.root}>
                    <EnhancedToolbar
                        title={t('playersList.title')}
                        categories={this.props.categories}
                        selectedCategory={this.props.selectedCategoryId}
                        handleCategorySelect={this.handleCategorySelect} />
                    <div className={classes.tableWrapper}>
                        <Table  className={classes.table} aria-labelledby="tableTitle">
                            <EnhancedTableHead columns={this.props.columns} order={order} orderBy={orderBy} onRequestSort={this.handleRequestSort} />
                            <TableBody>
                                {pageData.map(n => {
                                    let cells = [];
                                    if (n.players) {
                                        n.players.forEach((p) => {
                                            const country = countryMap[p.country] ? countryMap[p.country].name : p.country;
                                            cells.push(<TableCell key={p.id + "lastName"} >{p.lastName}</TableCell>);
                                            cells.push(<TableCell key={p.id + "firstName"}>{p.firstName}</TableCell>);
                                            cells.push(<TableCell key={p.id + "gender"}>{t('gender.' + p.gender)}</TableCell>);
                                            cells.push(<TableCell key={p.id + "country"}>{country}</TableCell>);
                                        });
                                    }
                                    return (
                                        <TableRow
                                            hover
                                            key={n.id}
                                        >
                                            {cells}
                                        </TableRow>
                                    );
                                })}
                                {emptyRows > 0 && (
                                    <TableRow style={{height: 49 * emptyRows}}>
                                        <TableCell colSpan={4} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50]}
                        component="div"
                        count={data.length}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        labelRowsPerPage={t('playersList.rowsPerPage')}
                        ActionsComponent={TablePaginationActions}
                    />
                </Paper>
                <div className={classes.regLink}>
                    <Trans ns="messages" i18nKey="playersList.gotoRegistrationLink">
                        Go to <Link component={RouterLink} to='/registration'>Registration Page</Link>.
                    </Trans>
                </div>
                {snackbar}
            </>
        )
    }
}

const mapStateToProps = (state) => {
    const categories = state.playersList.categories;
    return {
        instance: state.root.currentInstance,
        order: state.playersList.order,
        orderBy: state.playersList.orderBy,
        page: state.playersList.page,
        rowsPerPage: state.playersList.rowsPerPage,
        categories: categories,
        data: state.playersList.data,
        errorCode: state.playersList.errorCode,
        errorMessage: state.playersList.errorMessage,
        selectedCategoryId: state.playersList.selectedCategoryId,
        columns: state.playersList.columns
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCategoryEntries: (categoryId) => dispatch({type: actions.LOAD_CATEGORY_ENTRIES, categoryId: categoryId}),
        setPageSort: (order, orderBy) => dispatch({type: actions.SET_PLAYERS_PAGE_SORT, order: order, orderBy: orderBy}),
        setPageNum: (page) => dispatch({type: actions.SET_PAGE_NUMBER, page: page}),
        setRowsPerPage: (rowsPerPage) => dispatch({type: actions.SET_ROWS_PER_PAGE, rowsPerPage: rowsPerPage}),
        setPage: (page, order, orderBy) => dispatch({type: actions.SET_PAGE, page: page, order: order, orderBy: orderBy})
    };
}

export default withTranslation('messages')(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(PlayersList)));